import React, { useState } from 'react'
import { numberRegex, programDescriptionRegex, programNameRegex,emailRegex, passwordRegex } from '../regex/regex';
import SwitchButton from '../component/SwitchButton';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { StyledButton, StyledCancelButton } from '../component/StyledComponent';
export default function ProfileDialog({ open, onClose,profile,setProfile,onSubmit}) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth>
                <DialogTitle> {"Edit Admin"}  </DialogTitle>
                 
            <DialogContent className='space-y-5'>
                <TextField
                    autoFocus
                    label="Name"
                    fullWidth
                    variant="standard"
                    value={profile.name}
                    required
                    maxLength="256"
                    onChange={(e) => setProfile({ ...profile, name: e.target.value })}
                    error={!!profile.name && !programNameRegex.test(profile.name)} // Inline error handling
                />
                 <TextField
                    autoFocus
                    label="Email"
                    fullWidth
                    variant="standard"
                    value={profile?.email}
                    onChange={(e) => setProfile({ ...profile, email: e.target.value })}
                    error={!!profile.email && !emailRegex.test(profile.email)} // Inline error handling
                />
                    <TextField
                    autoFocus
                    label="Password"
                    fullWidth
                    variant="standard"
                    value={profile?.password}
                    required
                    maxLength="16"
                    onChange={(e) => setProfile({ ...profile, password: e.target.value })}
                    error={!!profile.password && !passwordRegex.test(profile.password)}  
                />
            </DialogContent>
            <DialogActions>
                <StyledCancelButton 
                onClick={onClose} 
                variant="outlined">Cancel</StyledCancelButton>
                <StyledButton 
                onClick={onSubmit} 
                disabled={profile.name 
                    && profile.email && profile.password  
                    && programNameRegex.test(profile.name) 
                    && passwordRegex.test(profile.password)
                    && emailRegex.test(profile.email)
                    ? false :true}
                autoFocus
                
                >
                    Save
                </StyledButton>
            </DialogActions>

        </Dialog>
    )
}
